import React from "react";
import { v4 as uuidv4 } from "uuid";

import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { Arrayify } from "../Functions/utils";
//import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const ToggleSet = ({ set = null, current = "", onChange = null }) => {

  const myChange = (e) => {
    let v = e // BS
    //let v = e.target.value //MUI
    if (onChange === null) {
      //console.log("null change")
      return
    }
    // console.log("Change")
    // console.log("Old " + current)
    // console.log("New" + v)
    onChange(v)
  }
  return (
    <ToggleButtonGroup
      key={"TS"}
      id={uuidv4()}
      type="radio"
      name="toggleSet"
      size="sm"
      value={current}
      onChange={myChange}
    >
      {Arrayify(set).map((lab, index) => (
        <ToggleButton
          className={
            current === lab ? "untoggled-button-active" : "untoggled-button"
          }
          key={"TS" + index}
          id={uuidv4()}
          name="toogleSet"
          type="radio"
          size="sm" // BS
          //size="small" // MUI
          checked={current === lab ? true : false}
          value={lab}
        >
          {lab}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ToggleSet;
